export const isEventFormFullscreen = (pathname: string) =>
  /^\/event\/(create|edit)\//.test(pathname) || pathname.startsWith('/event-duplicate/');
